/**
 * Background elements
 */

import { gsap } from "gsap"
import { isTablet } from "./utils"

declare var $

export class BackgroundElements {

  el: HTMLElement
  sectionCount: number
  bg_tl: TimelineLite

  constructor(el, sectionCount) {
    this.el = el
    this.sectionCount = sectionCount
    this.initBackground()
  }

  initBackground() {
    const $background = $('.background', this.el)
    this.bg_tl = gsap.timeline({
      scrollTrigger: {
        trigger: this.el,
        start: "top top",
        end: "bottom bottom",
        scrub: 0,
        //markers: true
      }
    })

    // Build blocks
    const block = $('<div class="bg-block"><div class="bg-block"></div></div>').appendTo($background)
    const frame = 1 / this.sectionCount
    const degToRad = (Math.PI / 180)
    const unit = isTablet()?'vh':'vw'

    this.bg_tl.set(block, { xPercent:-50, yPercent:-50 }, 0)
    let yP, scale, rotation, rotRad, sin, cos

    for(let i = 0; i < this.sectionCount; i++) {
      yP = -50 + (Math.random() * 150)
      scale = 0.5 + Math.random()
      rotation = Math.random() * 180
      rotRad = rotation * degToRad
      sin = Math.sin(rotRad)
      cos = Math.cos(rotRad)
      this.bg_tl
        .set(block, { yPercent: yP, scaleY: scale, x:(cos*-180) + unit, y:(sin*-180) + unit, rotate: rotation }, frame*(i+0.05))
        .to(block, { x:(cos*100) + unit, y:(sin*100) + unit, duration: frame*0.95 })
    }

    this.bg_tl.set(block, { opacity: 0 }, 1)

  }

}